import { useMutation } from '@tanstack/react-query';

import { DeleteSharedViewParameters } from '../../../../../../../typings/api/skymap/rest/v0/shared-view';
import { SkyMapAxiosServiceFactory } from '../../../../../services/axios/skymap-axios-service-factory';

const useDeleteQuery = () => {
  const { mutate, status, reset } = useMutation({
    mutationFn: async (form: DeleteSharedViewParameters) =>
      SkyMapAxiosServiceFactory.instance.createSharedViewServiceV0().deleteSharedView(form),
    retry: false,
    networkMode: 'always',
  });

  const deleteLink = async (sharedViewId: string) =>
    new Promise<void>((resolve, reject) => {
      mutate(
        {
          path: {
            id: sharedViewId,
          },
        },
        {
          onError: (err) => reject(err),
          onSuccess: () => resolve(),
        },
      );
    });

  return { deleteLink, status, reset };
};

export { useDeleteQuery };
